class AnalyticsClass {
  private static instance: AnalyticsClass;
  private readonly UTM_SOURCE_KEY = '@UtmSource';

  private constructor() {}

  static getInstance(): AnalyticsClass {
    if (!AnalyticsClass.instance) {
      AnalyticsClass.instance = new AnalyticsClass();
    }
    return AnalyticsClass.instance;
  }

  getUtmSource(): string | null {
    if (typeof window === 'undefined') {
      return null;
    }
    return localStorage.getItem(this.UTM_SOURCE_KEY);
  }

  setUtmSource(value: string | null): void {
    if (typeof window === 'undefined') {
      return;
    }
    if (value === null) {
      localStorage.removeItem(this.UTM_SOURCE_KEY);
    } else {
      localStorage.setItem(this.UTM_SOURCE_KEY, value);
    }
  }
}

export const Analytics = AnalyticsClass.getInstance();
